<template>
  <bareme-etape-1></bareme-etape-1>
</template>

<script>
import DossierDto from '@/models/DossierDto';
import BaremeEtape1 from '@/components/bareme/etapes/Etape1.vue';

export default {
  name: 'bareme-home',
  components: { BaremeEtape1 },
  created() {
    const dossier = new DossierDto();
    dossier.numeroAVS = '756.';

    this.$store.dispatch('dossier/setDossier', dossier);
  },
};
</script>

<style scoped>
  /deep/ .panel:last-child {
    margin-bottom: 20px;
  }
</style>
